import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["monthlyBtn", "yearlyBtn", "monthlyPrice", "yearlyPrice"]
  static values = { theme: { type: String, default: "dark" } }

  declare readonly monthlyBtnTargets: HTMLElement[]
  declare readonly yearlyBtnTargets: HTMLElement[]
  declare readonly monthlyPriceTargets: HTMLElement[]
  declare readonly yearlyPriceTargets: HTMLElement[]
  declare themeValue: string

  connect() {
    this.selectMonthly()
  }

  selectMonthly() {
    const isLight = this.themeValue === "light"

    // Update button styles
    this.monthlyBtnTargets.forEach((btn) => {
      if (btn.tagName === 'BUTTON') {
        if (isLight) {
          btn.classList.add('bg-white', 'text-gray-900', 'shadow-sm')
          btn.classList.remove('text-gray-500', 'hover:text-gray-700')
        } else {
          btn.classList.add('bg-sky-600', 'text-white')
          btn.classList.remove('text-slate-300', 'hover:text-white')
        }
      } else {
        btn.classList.remove('hidden')
      }
    })

    this.yearlyBtnTargets.forEach((btn) => {
      if (btn.tagName === 'BUTTON') {
        if (isLight) {
          btn.classList.remove('bg-white', 'text-gray-900', 'shadow-sm')
          btn.classList.add('text-gray-500', 'hover:text-gray-700')
        } else {
          btn.classList.remove('bg-sky-600', 'text-white')
          btn.classList.add('text-slate-300', 'hover:text-white')
        }
      } else {
        btn.classList.add('hidden')
      }
    })

    // Update price visibility
    this.monthlyPriceTargets.forEach((el) => el.classList.remove('hidden'))
    this.yearlyPriceTargets.forEach((el) => el.classList.add('hidden'))
  }

  selectYearly() {
    const isLight = this.themeValue === "light"

    // Update button styles
    this.yearlyBtnTargets.forEach((btn) => {
      if (btn.tagName === 'BUTTON') {
        if (isLight) {
          btn.classList.add('bg-white', 'text-gray-900', 'shadow-sm')
          btn.classList.remove('text-gray-500', 'hover:text-gray-700')
        } else {
          btn.classList.add('bg-sky-600', 'text-white')
          btn.classList.remove('text-slate-300', 'hover:text-white')
        }
      } else {
        btn.classList.remove('hidden')
      }
    })

    this.monthlyBtnTargets.forEach((btn) => {
      if (btn.tagName === 'BUTTON') {
        if (isLight) {
          btn.classList.remove('bg-white', 'text-gray-900', 'shadow-sm')
          btn.classList.add('text-gray-500', 'hover:text-gray-700')
        } else {
          btn.classList.remove('bg-sky-600', 'text-white')
          btn.classList.add('text-slate-300', 'hover:text-white')
        }
      } else {
        btn.classList.add('hidden')
      }
    })

    // Update price visibility
    this.yearlyPriceTargets.forEach((el) => el.classList.remove('hidden'))
    this.monthlyPriceTargets.forEach((el) => el.classList.add('hidden'))
  }
}
